export enum MeritPopulationChangeState {
  None = 'None',
  MeritPopulation = 'MeritPopulation',
  EquityPopulation = 'EquityPopulation'
}
